export const EncryptConstants = {
  ENCRYPTION_KEY_STORAGE_KEY: 'encryption_key',
  ENCRYPT: 'encrypt',
  DECRYPT: 'decrypt',
  AES_GCM: 'AES-GCM',
  LENGTH: 256,
  RAW: 'raw',
};
